import { render } from "./ItemListHeadBottom.vue?vue&type=template&id=42051a52&scoped=true"
import script from "./ItemListHeadBottom.vue?vue&type=script&lang=js"
export * from "./ItemListHeadBottom.vue?vue&type=script&lang=js"

import "./ItemListHeadBottom.vue?vue&type=style&index=0&id=42051a52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42051a52"]])

export default __exports__